.title {
  min-width: 0;
  margin-block: var(--rc-theme-spacing-xxs);
}
